import { C3HardwareItem, C3ProductVersion, MetalsHardwareItem, MetalsProductVersion, PlasticsHardwareItem, PlasticsMaterial, ProductVersion } from "@prism/prism-shared";

export interface FlowchartNode {
    id: string; // Unique identifier
    x: number; // X position (grid-aligned)
    y: number; // Y position (grid-aligned)
    imageUrl: string; // URL for image
    primaryText: string; // Primary text to display
    secondaryText: string; // Secondary text to display
    bottomText: string; // Badge text to display
}

export interface FlowchartLink {
    id: string; // Unique identifier
    from: string; // ID of source rectangle
    to: string; // ID of target rectangle
}

export interface FlowchartData {
    nodes: FlowchartNode[];
    links: FlowchartLink[];
}

export enum PlasticsTreeNodeType {
    ProductVersion = 'ProductVersion',
    Hardware = 'Hardware',
    Material = 'Material'
}

export enum MetalsTreeNodeType {
    ProductVersion = 'ProductVersion',
    Hardware = 'Hardware',
}

export enum C3TreeNodeType {
    ProductVersion = 'ProductVersion',
    Hardware = 'Hardware',
}


export interface PlasticsTreeNode {
    id: string;
    type: PlasticsTreeNodeType;
    data: ProductVersion | PlasticsHardwareItem | PlasticsMaterial;
    children: PlasticsTreeNode[];
    parentProductId: string;
    parentProductQuantity: number;
    quantity: number;
}

export interface MetalsTreeNode {
    id: string;
    type: MetalsTreeNodeType;
    data: MetalsProductVersion | MetalsHardwareItem;
    children: MetalsTreeNode[];
    quantity?: number;
}

export interface C3TreeNode {
    id: string;
    type: C3TreeNodeType;
    data: C3ProductVersion | C3HardwareItem;
    children: C3TreeNode[];
    quantity?: number;
}